import React from 'react';

//Public landing (Pengumuman Tender -- mockup, tanpa login)
import {
  NotFoundEntry,
  PrivacyPolicyEntry,
  RootEntry,
  TenderAnnouncementDetailEntry,
  TenderAnnouncementEntry,
} from './PublicEntry';

//Procurement
import Dashboard from '../pages/Dashboard';

//Procurement
import ProcurementView from '../pages/Procurement';
import ProcurementForm from '../pages/Procurement/ProcurementForm';

//Tender Opening
import TenderOpening from '../pages/TenderOpening';
import DetailProductHydro from '../pages/TenderOpening/components/Detail';

//RequestHps
import RequestHpsView from '../pages/RequestHps/HpsView';
import RequestHpsForm from '../pages/RequestHps/HpsForm';

//Hps
import HpsView from '../pages/Hps';
import HpsForm from '../pages/Hps/HpsForm';

//Invitation
import InvitationView from '../pages/Invitation/InvitationView';
import InvitationForm from '../pages/Invitation/InvitationForm';

//Offer
import OfferView from '../pages/Offer/OfferView';
import OfferForm from '../pages/Offer/OfferForm';

//FreightCost
import FreightCostView from '../pages/FreightCost';
import FreightCostForm from '../pages/FreightCost/FreightCostForm';

//Invitation Evaluation
import InvitationEvaluationView from '../pages/InvitationEvaluation';
import InvitationEvaluationForm from '../pages/InvitationEvaluation/InvitationEvaluationForm';

//Tender Evaluation
import TenderEvaluation from '../pages/TenderEvaluation';
import TenderEvaluationDetail from '../pages/TenderEvaluation/components/detail';

//Improvement Clarification
import ImprovementClarification from '../pages/ImprovementClarification';
import ImprovementClarificationDetail from '../pages/ImprovementClarification/components/detail';

//Awarding
import AwardingView from '../pages/Awarding';
import AwardingDetail from '../pages/Awarding/detail';
import AwardingSupplierView from '../pages/AwardingSupplier';
import AwardingSupplierDetail from '../pages/AwardingSupplier/detail';

//Negotiation
import NegotiationView from '../pages/Negotiation';
import NegotiationDetail from '../pages/Negotiation/detail';
import NegotiationSupplierView from '../pages/NegotiationSupplier';
import NegotiationSupplierDetail from '../pages/NegotiationSupplier/detail';

//Master
import TenderAnnouncementView from '../pages/TenderAnnouncement/TenderAnnouncementView';
import IncotermView from '../pages/Master/IncotermView';
import LawView from '../pages/Master/LawView';
import ArbitrationView from '../pages/Master/ArbitrationView';
import IncotermLocationView from '../pages/Master/IncotermLocationView';
import LocationView from '../pages/Master/LocationView';
import JettyLocationView from '../pages/Master/JettyLocationView';
import ProductView from '../pages/Master/ProductView';
import ProductTypeView from '../pages/Master/ProductTypeView';
import IndexPriceView from '../pages/Master/IndexPriceView';
import DocumentUploadMasterView from '../pages/Master/DocumentUploadMasterView';
import PaymentCurrencyView from '../pages/Master/PaymentCurrencyView';
import GtcView from '../pages/Master/GtcView';
import GtcDetailView from '../pages/Master/GtcDetailView';
import GtcAmendView from '../pages/Master/GtcAmendView';
import GtcAmendDetailView from '../pages/Master/GtcAmendDetailView';

import DocumentTemplateView from '../pages/Master/DocumentTemplateView';
import ClauseView from '../pages/Master/ClauseView';

//User Management
import UserManagementView from '../pages/UserManagement/UserManagementView';
import UserManagementDtl from '../pages/UserManagement/UserManagementForm';
import RolesView from '../pages/UserManagement/RolesView';

//System Info
import SystemVersion from '../pages/SystemVersion';

import Menu from '../pages/Menu';
import MenuAssignment from '../pages/MenuAssigment';
import Permission from '../pages/Permission';
import RolePermission from '../pages/RolePermission';
import PositionIdaman from '../pages/PositionIdaman';
import IdamanUser from '../pages/IdamanUser';

//Calendar
import Calendar from '../pages/Calendar/Maincalender';
import MonthGrid from '../pages/Calendar/MonthGrid';

// Email box
import MailInbox from '../pages/EmailInbox';

// Project
import ProjectList from '../pages/Projects/ProjectList';
import ProjectOverview from '../pages/Projects/ProjectOverview';
import CreateProject from '../pages/Projects/CreateProject';

//Task
import TaskDetails from '../pages/Tasks/TaskDetails';

//Forms
import BasicElements from '../pages/Forms/BasicElements/BasicElements';
import FormSelect from '../pages/Forms/FormSelect/FormSelect';

import CheckBoxAndRadio from '../pages/Forms/CheckboxAndRadio/CheckBoxAndRadio';
import Masks from '../pages/Forms/Masks/Masks';
import FileUpload from '../pages/Forms/FileUpload/FileUpload';
import FormPickers from '../pages/Forms/FormPickers/FormPickers';
import FormRangeSlider from '../pages/Forms/FormRangeSlider/FormRangeSlider';
import Formlayouts from '../pages/Forms/FormLayouts/Formlayouts';
import FormValidation from '../pages/Forms/FormValidation/FormValidation';
import FormWizard from '../pages/Forms/FormWizard/FormWizard';
import FormAdvanced from '../pages/Forms/FormAdvanced/FormAdvanced';
import Select2 from '../pages/Forms/Select2/Select2';

//Tables
import BasicTables from '../pages/Tables/BasicTables/BasicTables';
import ListTables from '../pages/Tables/ListTables/ListTables';
import ReactTable from '../pages/Tables/ReactTables';

//Icon pages
import RemixIcons from '../pages/Icons/RemixIcons/RemixIcons';
import BoxIcons from '../pages/Icons/BoxIcons/BoxIcons';
import MaterialDesign from '../pages/Icons/MaterialDesign/MaterialDesign';
import FeatherIcons from '../pages/Icons/FeatherIcons/FeatherIcons';
import LineAwesomeIcons from '../pages/Icons/LineAwesomeIcons/LineAwesomeIcons';
import CryptoIcons from '../pages/Icons/CryptoIcons/CryptoIcons';

//Maps

//AuthenticationInner pages

//pages
import Starter from '../pages/Pages/Starter/Starter';
import SimplePage from '../pages/Pages/Profile/SimplePage/SimplePage';
import Settings from '../pages/Pages/Profile/Settings/Settings';

import Timeline from '../pages/Pages/Timeline/Timeline';
import Faqs from '../pages/Pages/Faqs/Faqs';
import Pricing from '../pages/Pages/Pricing/Pricing';
import Gallery from '../pages/Pages/Gallery/Gallery';
import Maintenance from '../pages/Pages/Maintenance/Maintenance';
import ComingSoon from '../pages/Pages/ComingSoon/ComingSoon';
import SiteMap from '../pages/Pages/SiteMap/SiteMap';
import SearchResults from '../pages/Pages/SearchResults/SearchResults';

import BasicSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg';
import CoverSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg';

import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';

import Offlinepage from '../pages/AuthenticationInner/Errors/Offlinepage';

//APi Key
import APIKey from '../pages/APIKey/index';

//Activity Log
import ActivityLog from '../pages/ActivityLog';

//Warning
import NotAuthorize from '../pages/Error/Cover404';
import PageNotFound from '../pages/Error/Cover404notfound';

//login
import Login from '../pages/Authentication/Login';
import SupplierRegister from '../pages/Authentication/SupplierRegister';

import Logout from '../pages/Authentication/Logout';

import SigninOidc from '../pages/Authentication/SigninOidc';
import SignOutCallback from '../pages/Authentication/SignOutCallback'; // pastikan path benar

import PrivecyPolicy from '../pages/Pages/PrivacyPolicy';
import TermsCondition from '../pages/Pages/TermsCondition';

// User Profile
import UserProfile from '../pages/Authentication/user-profile';

import BlogListView from '../pages/Pages/Blogs/ListView';
import BlogGridView from '../pages/Pages/Blogs/GridView';
import PageBlogOverview from '../pages/Pages/Blogs/Overview';

const authProtectedRoutes = [
  { path: '/dashboard', component: <Dashboard /> },
  { path: '/index', component: <Dashboard /> },
  { path: '/dashboard-procurement', component: <Dashboard /> },
  { path: '/apps-calendar', component: <Calendar /> },
  { path: '/apps-calendar-month-grid', component: <MonthGrid /> },

  //Dashboard
  { path: '/dashboard/view', component: <Dashboard /> },

  //Procurement
  {
    path: '/apps-procurement/view',
    component: <ProcurementView />,
  },

  {
    path: '/apps-procurement/upd/:id',
    component: <ProcurementForm />,
  },

  // Tender Opening
  {
    path: '/apps-tenderopening/view',
    component: <TenderOpening />,
  },
  {
    path: '/apps-tenderopening/dtl/:id',
    component: <DetailProductHydro />,
  },

  //Hps Request
  {
    path: '/apps-requesthps/view',
    component: <RequestHpsView />,
  },

  {
    path: '/apps-requesthps/upd/:id',
    component: <RequestHpsForm />,
  },

  //Hps TAD
  {
    path: '/apps-hps/view',
    component: <HpsView />,
  },

  {
    path: '/apps-hps/upd/:id',
    component: <HpsForm />,
  },

  //Tender Invitation
  {
    path: '/apps-invitation/view',
    component: <InvitationView />,
  },

  {
    path: '/apps-invitation/dtl/:id',
    component: <InvitationForm />,
  },

  //Tender Offer
  {
    path: '/apps-offer/view',
    component: <OfferView />,
  },

  {
    path: '/apps-offer/dtl/:id',
    component: <OfferForm />,
  },

  //Freight Cost
  {
    path: '/apps-freightcost/view',
    component: <FreightCostView />,
  },

  {
    path: '/apps-freightcost/upd/:id',
    component: <FreightCostForm />,
  },

  //Invitation Evaluation
  {
    path: '/apps-evaluation-invitation/view',
    component: <InvitationEvaluationView />,
  },

  {
    path: '/apps-evaluation-invitation/upd/:id',
    component: <InvitationEvaluationForm />,
  },

  //Tender Evaluation
  {
    path: '/apps-tenderevaluation/view',
    component: <TenderEvaluation />,
  },

  {
    path: '/apps-tenderevaluation/dtl/:id/*',
    component: <TenderEvaluationDetail />,
  },

  //Improvement Clarification
  {
    path: '/apps-improvementclarification/view',
    component: <ImprovementClarification />,
  },

  {
    path: '/apps-improvementclarification/dtl/:id',
    component: <ImprovementClarificationDetail />,
  },

  //Awarding
  {
    path: '/apps-awarding/view',
    component: <AwardingView />,
  },

  {
    path: '/apps-awarding/dtl/:id',
    component: <AwardingDetail />,
  },

  {
    path: '/apps-awarding-supplier/view',
    component: <AwardingSupplierView />,
  },

  {
    path: '/apps-awarding-supplier/dtl/:id',
    component: <AwardingSupplierDetail />,
  },

  //Negotiation
  {
    path: '/apps-negotiation/view',
    component: <NegotiationView />,
  },
  {
    path: '/apps-negotiation/dtl/:id',
    component: <NegotiationDetail />,
  },
  {
    path: '/apps-negotiation-supplier/view',
    component: <NegotiationSupplierView />,
  },
  {
    path: '/apps-negotiation-supplier/dtl/:id',
    component: <NegotiationSupplierDetail />,
  },

  //Master

  {
    path: '/apps-tender-announcement/view',
    component: <TenderAnnouncementView />,
  },

  {
    path: '/apps-gtc-view',
    component: <GtcView />,
  },

  {
    path: '/apps-gtc-view/dtl/:id',
    component: <GtcDetailView />,
  },

  {
    path: '/apps-gtc-amend/view',
    component: <GtcAmendView />,
  },

  {
    path: '/apps-gtc-amend/dtl/:id',
    component: <GtcAmendDetailView />,
  },

  {
    path: '/apps-incoterm-view',
    component: <IncotermView />,
  },

  {
    path: '/apps-law-view',
    component: <LawView />,
  },

  {
    path: '/apps-arbitration-view',
    component: <ArbitrationView />,
  },

  { path: '/apps-arbitration-view', component: <ArbitrationView /> },
  { path: '/apps-incoterm-location-view', component: <IncotermLocationView /> },
  { path: '/apps-location-view', component: <LocationView /> },
  { path: '/apps-jetty-location-view', component: <JettyLocationView /> },

  {
    path: '/apps-product/view',
    component: <ProductView />,
  },

  {
    path: '/apps-product-type-view/view',
    component: <ProductTypeView />,
  },

  {
    path: '/apps-indexprice/view',
    component: <IndexPriceView />,
  },

  {
    path: '/apps-document-upload-master/view',
    component: <DocumentUploadMasterView />,
  },

  {
    path: '/apps-payment-currency/view',
    component: <PaymentCurrencyView />,
  },

  {
    path: '/apps-document-template/view',
    component: <DocumentTemplateView />,
  },

  {
    path: '/apps-clause/view',
    component: <ClauseView />,
  },

  //EMail
  {
    path: '/apps-mailbox/view',
    component: <MailInbox />,
  },

  //User Management
  {
    path: '/apps-usermanagement/view',
    component: <UserManagementView />,
  },

  {
    path: '/apps-usermanagement/dtl/:id',
    component: <UserManagementDtl />,
  },

  // Roles
  {
    path: '/apps-roles/view',
    component: <RolesView />,
  },

  //Menu
  {
    path: '/apps-menumanagement/view',
    component: <Menu />,
  },

  {
    path: '/apps-menuassignment/view',
    component: <MenuAssignment />,
  },

  //Permission
  {
    path: '/apps-permission/view',
    component: <Permission />,
  },

  {
    path: '/apps-role-permission/view',
    component: <RolePermission />,
  },

  //Position ID IDAMAN (Super Admin)
  {
    path: '/apps-position-id/view',
    component: <PositionIdaman />,
  },
  {
    path: '/apps-idaman-user/view',
    component: <IdamanUser />,
  },

  //Activity Log
  {
    path: '/apps-activity-log/view',
    component: <ActivityLog />,
  },

  //Projects
  { path: '/apps-projects-list', component: <ProjectList /> },
  { path: '/apps-projects-overview', component: <ProjectOverview /> },
  { path: '/apps-projects-create', component: <CreateProject /> },

  //Task
  { path: '/apps-tasks-details', component: <TaskDetails /> },

  //Api Key
  { path: '/apps-api-key', component: <APIKey /> },

  // Forms
  { path: '/forms-elements', component: <BasicElements /> },
  { path: '/forms-select', component: <FormSelect /> },

  { path: '/forms-checkboxes-radios', component: <CheckBoxAndRadio /> },
  { path: '/forms-masks', component: <Masks /> },
  { path: '/forms-file-uploads', component: <FileUpload /> },
  { path: '/forms-pickers', component: <FormPickers /> },
  { path: '/forms-range-sliders', component: <FormRangeSlider /> },
  { path: '/forms-layouts', component: <Formlayouts /> },
  { path: '/forms-validation', component: <FormValidation /> },
  { path: '/forms-wizard', component: <FormWizard /> },
  { path: '/forms-advanced', component: <FormAdvanced /> },
  { path: '/forms-select2', component: <Select2 /> },

  //Tables
  { path: '/tables-basic', component: <BasicTables /> },
  { path: '/tables-listjs', component: <ListTables /> },
  { path: '/tables-react', component: <ReactTable /> },

  //Icons
  { path: '/icons-remix', component: <RemixIcons /> },
  { path: '/icons-boxicons', component: <BoxIcons /> },
  { path: '/icons-materialdesign', component: <MaterialDesign /> },
  { path: '/icons-feather', component: <FeatherIcons /> },
  { path: '/icons-lineawesome', component: <LineAwesomeIcons /> },
  { path: '/icons-crypto', component: <CryptoIcons /> },

  //Maps

  //Pages
  { path: '/pages-starter', component: <Starter /> },
  { path: '/pages-profile', component: <SimplePage /> },
  { path: '/pages-profile-settings', component: <Settings /> },

  { path: '/pages-timeline', component: <Timeline /> },
  { path: '/pages-faqs', component: <Faqs /> },
  { path: '/pages-gallery', component: <Gallery /> },
  { path: '/pages-pricing', component: <Pricing /> },
  { path: '/pages-sitemap', component: <SiteMap /> },
  { path: '/pages-search-results', component: <SearchResults /> },
  { path: '/pages-privacy-policy', component: <PrivecyPolicy /> },
  { path: '/pages-terms-condition', component: <TermsCondition /> },
  { path: '/pages-blog-list', component: <BlogListView /> },
  { path: '/pages-blog-grid', component: <BlogGridView /> },
  { path: '/pages-blog-overview', component: <PageBlogOverview /> },

  //User Profile
  { path: '/profile', component: <UserProfile /> },
];

const publicRoutes = [
  // Warning Page
  { path: '/notauthorized', component: <NotAuthorize /> },
  { path: '/pagenotfound', component: <PageNotFound /> },

  // Authentication Page
  { path: '/logout', component: <Logout /> },
  { path: '/login', component: <Login /> },
  // Registrasi mandiri Registered Supplier (email trader DMUT) + enroll MFA.
  { path: '/register-supplier', component: <SupplierRegister /> },

  { path: '/signin-oidc', component: <SigninOidc /> },
  { path: '/signout-callback-oidc', component: <SignOutCallback /> },

  //AuthenticationInner pages
  { path: '/auth-success-msg-basic', component: <BasicSuccessMsg /> },
  { path: '/auth-success-msg-cover', component: <CoverSuccessMsg /> },
  { path: '/auth-404-basic', component: <Basic404 /> },
  { path: '/auth-404-cover', component: <Cover404 /> },
  { path: '/auth-404-alt', component: <Alt404 /> },
  { path: '/auth-500', component: <Error500 /> },
  { path: '/pages-maintenance', component: <Maintenance /> },
  { path: '/pages-coming-soon', component: <ComingSoon /> },

  { path: '/auth-offline', component: <Offlinepage /> },

  // Info versi & waktu update terakhir BE/FE -- sengaja publik agar bisa
  // diverifikasi tim infra/QA sesudah deploy tanpa perlu login.
  { path: '/version', component: <SystemVersion /> },

  // Pengumuman Tender publik (MOCKUP, data contoh di FE).
  // `layout: 'none'` -- komponen entry memasang PublicLayout sendiri supaya
  // navbar tidak berkedip saat flag mati dan halaman dialihkan ke /login.
  {
    path: '/tender-announcement',
    component: <TenderAnnouncementEntry />,
    layout: 'none',
  },
  {
    path: '/tender-announcement/:id',
    component: <TenderAnnouncementDetailEntry />,
    layout: 'none',
  },
  {
    path: '/privacy-policy',
    component: <PrivacyPolicyEntry />,
    layout: 'none',
  },

  // Dua route di bawah ini harus tetap berada di urutan paling akhir.
  { path: '/', exact: true, component: <RootEntry />, layout: 'none' },
  { path: '*', component: <NotFoundEntry />, layout: 'none' },
];

export { authProtectedRoutes, publicRoutes };
